import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import '../styles/PanelIcon.css';

const PanelIcon = ({ Icon, label , to, type = 'normal' }) => {
  var panelClass = 'panel-icon-normal';

  const location = useLocation();
  const path = location.pathname;
  if(path.startsWith(to)) panelClass = "panel-icon-selected";

  const navigate = useNavigate();

  const handleClick = () => {
    if (to) navigate(to);
  };

  return (
    <div className={panelClass} onClick={handleClick}>
      <Icon height={"100%"} />
      {label}
    </div>
  ); 
};

export default PanelIcon;